"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Warning = function Warning(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    viewBox: "0 0 32 32",
    width: "24",
    height: "24",
    fill: "currentColor"
  }, _react["default"].createElement("path", {
    d: "M16 3.22l-.88 1.5-12 20.78-.84 1.5h27.44l-.84-1.5-12-20.78zm0 4L26.25 25H5.75zM15 14v6h2v-6zm0 7v2h2v-2z"
  }));
};

Warning.propTypes = {
  className: _propTypes["default"].string
};
var _default = Warning;
exports["default"] = _default;